/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import Component from 'inferno-component';
// STYLES
// (css-in-js, imported as JS from external file, turned into CSS via library used in utils)
import styles from 'components/shared/title/title_styles';
import { createStyles } from 'utils/styles';
const sheet = createStyles(styles, {link:false});


/* ========== ~~~~~~~~~~ TITLE : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
const Title = (props) => {
	return (
        <div className={`${sheet.classes.title} title`}>
        	<h2>{props.children}</h2>
        </div>
	);
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default Title;
